import SalesReturnList from '../Components/Admin/SalesReturnList'

function SalesReturnPage() {
  return (
    <>
      <SalesReturnList />
    </>
  )
}

export default SalesReturnPage
